// extracted by mini-css-extract-plugin
export default {"container":"loader_container__gDtBB","logo":"loader_logo__Shiwg","spin":"loader_spin__DCnfF","pulse":"loader_pulse__MK1Dp","text":"loader_text__WPn6f","fade":"loader_fade__N+-E8"};